import { OSService } from "../../../services/os-service";
import { Component, OnInit, AfterContentInit } from "@angular/core";
import { CentroCustoService } from "src/app/services/centro.custo.service";
import { SpvService } from "src/app/services/spv.service";
import { CentroCusto } from "src/app/models/centrocusto.model";
import { CentroCustoDetalhes } from "src/app/models/centroCustoDetalhes.model";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { SpvDetalhes } from "src/app/models/spvDetalhes.model";
import { ActivatedRoute, Router } from "@angular/router";
import { UsuarioService } from "src/app/services/usuario.service";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { CommandResult } from "../../domain/commandResult";
import { Photo } from "../../os/fechar-os/photo.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UploadPhoto } from "../../os/fechar-os/upload-photo.model";
import { Util } from "src/app/utils/util.util";
import { FecharOSService } from "../../os/fechar-os/fechar-os.service";
import { FotoBase64ViewModel } from "../../domain/viewmodels.models";
import Swal from "sweetalert2";
import { APP_SETTINGS } from "src/environments/environment";
import { ImagemUtil } from "src/app/utils/Imagem.util";

@Component({
  selector: "app-solicitar-ss-cadastrar",
  templateUrl: "./solicitar-ss-cadastrar.component.html",
  styleUrls: ["./solicitar-ss-cadastrar.component.scss"],
  providers: [CentroCustoService, SpvService],
})
export class SolicitarSSCadastrarComponent implements OnInit, AfterContentInit {
  constructor(
    private centroCustoService: CentroCustoService,
    private spvService: SpvService,
    private toastr: ToastrService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private fechamentoOSService: FecharOSService,
    private osService: OSService
  ) {}

  centroCustoDetalhes: CentroCustoDetalhes = null;
  centrosDeCusto: CentroCusto[] = [];
  isNovoCadastro = true;
  isSalvando = false;
  autorizacoes: UsuarioAutorizacoes;
  autorizacaoAdicionarFoto: boolean;

  files: File[] = []; // armazena os arquivo de fotos
  previewsPhotos: Photo[] = []; // armazena as photos em base 64 para exibição
  previewPhotoSelecionada: Photo; // dataUrl (base 64) da foto clicada
  photoForm: FormGroup;
  isLoadingRegistroFotografico: boolean = false;
  uploadPhotos: UploadPhoto[] = [];
  isRemoveProcessing: boolean;

  form: FormGroup = null;
  requeridoRamalCentroCusto: boolean = APP_SETTINGS.requeridoRamalCentroCusto;
  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;
  requeridoLocalizacao: boolean = APP_SETTINGS.requeridoLocalizacao;

  ngOnInit() {
    this.resetForm();
    this.resetPhotoForm();
    /*  this.centroCustoService.getCentrosCustos().subscribe((response: CentroCusto[]) => { this.centrosDeCusto = response; },
      (err: any) => {
        this.toastr.error('Erro ao tentar obter lista de Centros Custos');
      }); */

   this.getCentroCustos();

    const param = this.activatedRouter.snapshot.params["id"];
    this.isNovoCadastro = param === undefined || param === "";

    if (!this.isNovoCadastro) {
      this.getById(parseInt(param));
    }

    document.getElementById("requisitante").focus();
  }

  ngAfterContentInit(): void {
    this.autorizacoes =
      this.usuarioService.getAutorizacoesJanelaPorRota("solicitar-spv");
    this.autorizacaoAdicionarFoto =
      this.usuarioService.getAutorizacoesEspecificaPorRota(
        "ss-pt-programar-servico",
        "adicionar-fotos-antes"
      );
  }

  getCentroCustos(): void {
  this.centroCustoService.getCentrosCustosx().then((response) => {
      this.centrosDeCusto = response;
    });
  }

  resetForm() {
    this.form = this.formBuilder.group({
      id: [""],
      requisitante: ["", [Validators.maxLength(20)]],
      contato: ["", [Validators.maxLength(40)]],
      localizacao: ["", [Validators.maxLength(40)]],
      servico: [""],
      centroCustoId: [""],
      tipoSpv: [1],
      datalistCentroCustos: [],
      uploadPhotos: [],
    });
  }

  resetPhotoForm() {
    this.photoForm = this.formBuilder.group({
      photo: ["", [Validators.required]],
    });
  }

  //Todo: ???
  getCentroCustoDetalhes(id: number) {
    if (id > 0) {
      this.centroCustoService.getCentroCustoDetalhes(id).subscribe(
        (response: CentroCustoDetalhes) => {
          this.centroCustoDetalhes = response;
        },
        (err: any) => {
          this.toastr.error("Erro ao tentar detalhes do item selecionado");
        }
      );
    } else {
      this.centroCustoDetalhes = null;
    }
  }

  submit() {
    if (this.validForm()) {
      this.isSalvando = true;

      if (this.isNovoCadastro) {
        this.form.get("id").setValue(0);
      }

      this.form.get("tipoSpv").setValue(1);

      if (this.form.get("servico").value != "") {
        this.form
          .get("servico")
          .setValue(String(this.form.get("servico").value).toUpperCase());
      }

      this.uploadPhotos = [];

      let count = 0;
      if (this.files.length > 0) {
        for (const f of this.files) {
          count++;
          this.uploadPhotos.push({
            id: 0,
            arquivoNomeOriginal: f.name,
            arquivoNome: Util.getArquivoNome(this.form.get("id").value, count),
            osFechamentoId: null,
            spvId: 0,
            atividadeId: null,
          });
        }
      }

      this.form.get("uploadPhotos").setValue(this.uploadPhotos);

      this.spvService.save(this.form.value).subscribe(
        (response: CommandResult) => {
          if (response.success === true) {
            this.toastr.success(response.message);

            if (this.files.length > 0) {
              this.fechamentoOSService
                .uploadPhotos(this.files, this.uploadPhotos)
                .subscribe(
                  () => {
                    this.reset();
                  },
                  (exception: any) => {
                    this.showErrorExecption(exception);
                  }
                );
            } else {
              this.reset();
            }
          } else {
            this.toastr.error(response.message);
          }

          this.isSalvando = false;
        },
        (exception: any) => {
          this.showErrorExecption(exception);
          this.isSalvando = false;
        },
        () => (this.isSalvando = false)
      );
    }
  }

  validForm() {
    let isFormValid: boolean = true;

    const dadosForm = this.form.value;

    if (this.requeridoRamalCentroCusto) {
      if (dadosForm.contato == "") {
        this.form.get("contato").setErrors({ isNotValidRamal: true });
        isFormValid = false;
      }

      if (dadosForm.centroCustoId == "") {
        this.form
          .get("centroCustoId")
          .setErrors({ isNotValidCentroCusto: true });
        isFormValid = false;
      }
    }

    if (this.requeridoLocalizacao) {
      if (dadosForm.localizacao == "") {
        this.form.get("localizacao").setErrors({ isNotValidLocalizacao: true });
        isFormValid = false;
      }
    }

    if (dadosForm.requisitante == "") {
      this.form.get("requisitante").setErrors({ isNotValidRequisitante: true });
      isFormValid = false;
    }

    if (dadosForm.servico == "") {
      this.form.get("servico").setErrors({ isNotValidServico: true });
      isFormValid = false;
    }

    return isFormValid;
  }

  reset() {
    this.resetForm();
    this.isSalvando = false;
    this.isNovoCadastro = true;
    this.router.navigate(["solicitar-spv/cadastrar"]);
    document.getElementById("requisitante").focus();
    this.centroCustoDetalhes = null;

    this.files = [];
    this.resetPhotoForm();
    this.previewsPhotos = [];
    this.previewPhotoSelecionada = null;

    this.uploadPhotos = [];
  }

  getById(id: number): void {
    this.previewsPhotos = [];
    this.previewPhotoSelecionada = null;
    this.files = [];
    this.isLoadingRegistroFotografico = true;

    this.spvService.getById(id).subscribe(
      (response: any) => {
        const formEdit = {
          id: response.id,
          requisitante: response.requisitante,
          contato: response.contato,
          localizacao: response.localizacao,
          servico: String(response.servico).toUpperCase(),
          centroCustoId: response.centroCustoId ? response.centroCustoId : "",
          tipoSpv: response.tipoSpv,
          datalistCentroCustos: response.centroCusto? response.centroCusto.nome : "",
          uploadPhotos: [],
        };
        this.form.setValue(formEdit);
        
        if (formEdit.centroCustoId) {
        this.getCentroCustoDetalhes(response.centroCustoId);
        }

        this.uploadPhotos = response.uploadPhotos;

        this.fechamentoOSService
          .getArrayFotosBase64(this.uploadPhotos)
          .subscribe((responseFotos: FotoBase64ViewModel[]) => {
            responseFotos.forEach((foto) => {
              this.handleFile(
                [].concat(
                  Util.dataURLtoFile(foto.base64String, foto.arquivoNome)
                ),
                false
              );
              this.previewsPhotos.push({
                dataUrl: foto.base64String,
                name: foto.arquivoNome,
              });
            });
            this.isLoadingRegistroFotografico = false;
          });
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter o SS");
      }
    );
  }

  // Métodos privates

  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) {
      msg = "A aplicação não conseguiu se conectar ao Servidor";
    }
    if (Number(exception.status) === 500) {
      msg = "O Servidor gerou um erro de processamento";
    }
    this.toastr.error(
      `<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`
    );
  }

  limparDataListCentroCustos() {
    this.form.get("datalistCentroCustos").setValue("");
  }

  changeDataListCentroCustos(value: string) {
    let item;
    if (value != "") {
      item = this.centrosDeCusto.filter((t) =>
        t.nome.toLowerCase().includes(value.toLowerCase())
      )[0];
    }
    if (item != undefined) {
      this.form.get("datalistCentroCustos").setValue(item.nome);
      this.form.get("centroCustoId").setValue(item.id);
      this.getCentroCustoDetalhes(item.id);
    } else {
      this.form.get("datalistCentroCustos").setValue("");
      this.form.get("centroCustoId").setValue("");
    }
  }

  openModalExibePhoto(modal, pview) {
    this.previewPhotoSelecionada = pview;
    this.modalService.open(modal, {
      windowClass: "zoomPhotoModal",
      backdrop: "static",
    });
  }

  handleFile(files: File[], addPreviewsPhotos: boolean = true) {
    ImagemUtil.handleFile(
      files,
      this.files,
      this.previewsPhotos,
      this.isLoadingRegistroFotografico,
      addPreviewsPhotos
    );
    this.photoForm.get("photo").setValue("");
  }

  removerPhoto(name: string) {
    let jaPersistido: boolean = false;

    const uploadPhoto = this.uploadPhotos.find((t) => t.arquivoNome == name);

    if (uploadPhoto != undefined) {
      jaPersistido = uploadPhoto.id > 0;
    }

    if (jaPersistido == false) {
      this.previewsPhotos = this.previewsPhotos.filter(
        (photo: Photo) => photo.name !== name
      );
      this.files = this.files.filter((f) => f.name !== name);
    } else {
      this.removerPhotoPersistida(name, uploadPhoto.id);
    }
  }

  public removerPhotoPersistida(name: string, uploadPhotoId: number) {
    Swal({
      title: "Excluir",
      text: "Deseja remover o registro fotográfico selecionado?",
      type: "question",
      showCancelButton: true,
      cancelButtonText: "Não",
      showConfirmButton: true,
      confirmButtonText: "Sim",
      cancelButtonColor: "#d33",
      focusCancel: true,
    }).then((result) => {
      if (result.value) {
        this.delete(name, uploadPhotoId);
      }
    });
  }

  private delete(name: string, uploadPhotoId: number): void {
    this.isRemoveProcessing = true;

    this.osService.removerUploadPhoto(uploadPhotoId).subscribe(
      (response: CommandResult) => {
        const cmdResult = new CommandResult(
          response.success,
          response.message,
          response.notifications,
          response.data
        );

        if (cmdResult.success === true) {
          this.toastr.success(cmdResult.message);
          this.previewsPhotos = this.previewsPhotos.filter(
            (photo: Photo) => photo.name !== name
          );
          this.files = this.files.filter((f) => f.name !== name);
        } else {
          this.toastr.warning(cmdResult.message);
        }

        this.isRemoveProcessing = false;
      },
      (exception: any) => {
        const cmdResult = new CommandResult(false, "", [], null);
        cmdResult.showErrorExecption(exception);
        this.isRemoveProcessing = false;
      },

      () => (this.isRemoveProcessing = false)
    );
  }
}
